'use client'
import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useQueryState, parseAsBoolean } from 'nuqs';

import { SidebarOverlay } from './components/sidebar-overlay';
import { SidebarGeneral } from './components/sidebar-general';
import { SidebarWorldMenu } from './components/sidebar-world-menu';
import { SidebarSports } from './components/sidebar-sports';
import clsx from 'clsx';
import { sidebarStyle } from './sidebar.style';
import { SidebarCategory } from './components/sidebar-category';
import { SideBarContextProvider } from './contexts/sidebar-context';
import { useAuthToken } from '@/store/auth';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { use3rdPartyProductList } from '@/hooks';
import Link from 'next/link';
import { ReturnIcon } from '@/components/icons/svg-icons';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useTranslations } from 'next-intl';
import { uiService } from '@/services/ui.service';
import { useStore } from '@/hooks';
import { useSiteStore } from '@/store/site';
import { useGetSiteConfigs, useGetSiteConfigsWithSession } from '@/hooks/query/use-site-configs';
import { SwitchFromEnum } from '@nf/types/site';
import { SideBarUserInfo } from './components/side-bar-user-info';
import { Logo } from '@/components/core/logo/logo';
// import { SidebarPromo } from './components/sidebar-promo';

const SidebarSection = dynamic(() =>
	import('./components/sidebar-section').then(m => m.SidebarSection)
);

export function Sidebar() {
	const { SiteConfigsWithSessionData } = useGetSiteConfigsWithSession();
	const authToken = useAuthToken();
	const isBefore = !authToken;
	const view = useAppearanceStore(state => state.view);
	const { thirdPartyGameList } = use3rdPartyProductList();
	const t = useTranslations('General');
	const homeUrl = useStore(useSiteStore, state => state.deepLinkSiteInfo.homeUrl);
	const platFrom = SiteConfigsWithSessionData?.SwitchFrom;
	const { SiteConfigsData } = useGetSiteConfigs();
	const [sidebarOpen, setSidebarOpen] = useQueryState(
		'sidebarOpen',
		parseAsBoolean.withDefault(false)
	);

	const isHeadlessStyle = view === ViewEnum.galaxy && SiteConfigsData?.EnableHeadlessForGalaxy;

	useEffect(() => {
		if (sidebarOpen) {
			uiService.controlSidebar(true);
			setSidebarOpen(null);
		}
	}, [sidebarOpen, setSidebarOpen]);

	const handleClick = () => {
		const isMobileMode = window.innerWidth < 750;
		if (view === ViewEnum.mars) {
			setKafkaNormal({
				note: KafkaNote.MarsV1,
				type: 4,
				action: isMobileMode ? 22 : 23
			})
		} else {
			setKafkaNormal({
				note: KafkaNote.GalaxyV2,
				type: 4,
				action: 1
			})
		}
	}

	return (
		<div className="main-wrap__side-nav">
			<SidebarOverlay />
			<div className={
				clsx(
					'side-nav',
					{ [sidebarStyle.leftMenu]: view === ViewEnum.mars }
				)}
			>
				<SideBarContextProvider>					
					{ 
						isHeadlessStyle && 
							<>
								<div className="side-nav__logo">
									<Logo />
								</div>
								{!isBefore && <SideBarUserInfo />}
							</>
					}
					
					{
						homeUrl && platFrom !== SwitchFromEnum.Desktop ?
							<Link
								onClick={handleClick}
								href={homeUrl}
							>
								<div className="side-back">
									<ReturnIcon />
									{
										SiteConfigsData?.GetMessageID === '4369900' ?
											<div className="text">{t('lbl_EVOIOBackToCasino')}</div>
											:
											<div className="text">{t('lbl_BackToMainSite')}</div>
									}
								</div>
							</Link> : null
					}

					{isBefore || thirdPartyGameList.filter(item => item.enable).length === 0 ? null : <SidebarCategory />}
					{/* {view === ViewEnum.galaxy ? <BackToMainSite style={null} /> : null} */}
					<SidebarGeneral />
					
					{/* Galaxy for Sections */}
					{view === ViewEnum.galaxy ? (
						<SidebarSection />
					) : null}

					{/* 停用 Tournament Widget Sidebar (2026 world cup) */}
					{/* <SidebarPromo /> */}
					<SidebarWorldMenu />
					<SidebarSports />
				</SideBarContextProvider>
			</div>
		</div>
	);
}